export const otpBaseUrl = '/api-otp';
export const mdmBaseUrl = '/api-mdm';
export const authBaseUrl = '/api-auth';